<template>
    <div class="page-wrapper bg-white radius-lg padding margin-left-sm">
        <div class="status flex"  :class="state | status_color" v-if="state !== -1">
            <div class="text-sm text-white">{{state | status}}</div>
            <div class="text-sm margin-left-xs text-white" v-if="state === 2">{{reason}}</div>
        </div>
        <div class="page-list flex flex-direction margin-top-sm">
            <el-table
                v-loading="loading"
                :data="lists"
                :span-method="objectSpanMethod"
                :summary-method="getSummaries"
                border
                header-row-class-name="table-header"
                show-summary
                style="width: 100%">
                <el-table-column label="一级指标" prop="one_name">
                    <template slot-scope="scope">
                        <div class="table-item text-bold">
                            {{ scope.row.one_name || '--' }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="一级指标权重赋分" prop="one_score" width="180">
                    <template slot-scope="scope">
                        <div class="table-item">
                            <el-input v-model.number="scope.row.one_score" disabled type="number"></el-input>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="二级指标" prop="two_name">
                    <template slot-scope="scope">
                        <div class="table-item cursor" @click="addTask(scope.row.two_id)">
                            {{ scope.row.two_name || '--' }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="二级指标权重赋分" prop="two_score" width="180">
                    <template slot-scope="scope">
                        <div v-if="scope.row.two_id" class="table-item">
                            <el-input v-model.number="scope.row.two_score" placeholder="请输入" type="number" :disabled="readonly" @input="inputChange(scope.row.one_id,'one_id','two_score','one_score')"></el-input>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="三级指标" prop="three_name">
                    <template slot-scope="scope">
                        <div class="table-item cursor" @click="addTask(scope.row.three_id)">
                            {{ scope.row.three_name || '--' }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="三级指标权重赋分" prop="three_score" width="180">
                    <template slot-scope="scope">
                        <div v-if="scope.row.three_id" class="table-item">
                            <el-input v-model.number="scope.row.three_score" placeholder="请输入" type="number" :disabled="readonly" @input="inputChange(scope.row.two_id,'two_id','three_score','two_score')"></el-input>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="四级指标" prop="four_name">
                    <template slot-scope="scope">
                        <div class="table-item cursor" @click="addTask(scope.row.four_id)">
                            {{ scope.row.four_name || '--' }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="四级指标权重赋分" prop="four_score" width="180">
                    <template slot-scope="scope">
                        <div v-if="scope.row.four_id" class="table-item">
                            <el-input v-model.number="scope.row.four_score" placeholder="请输入" type="number" :disabled="readonly" @input="inputChange(scope.row.three_id,'three_id','four_score','three_score')"></el-input>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <el-button class="btn max bg-orange radius self-center margin-top" type="warning" @click="submitApply" :loading="loading" v-if="!readonly">
                提交审核
            </el-button>
        </div>
        <task-detail-task-dialog :dialog-visible="addTaskDialog" :tid="cur_task_id" :readonly="false" @watchDetailState="watchDetailState"></task-detail-task-dialog>
    </div>
</template>

<script>

import {getProjectStatus, getTaskScoreEx, setTaskScoreEx} from "@/api";
import TaskDetailTaskDialog from "@/views/web/staff/components/TaskDetailTaskDialog";
import {TOAST, toast} from "@/utils/utils";

export default {
    name: "task-assignment",
    components: {TaskDetailTaskDialog},
    data() {
        return {
            pid: 0,
            pname: '',
            lists: [],
            loading: false,
            cur_task_id: 0,
            cur_task_sid: 0,
            addTaskDialog: false,
            column_1: [],
            pos_1: 0,
            column_2: [],
            pos_2: 0,
            column_3: [],
            pos_3: 0,
            column_4: [],
            pos_4: 0,
            readonly:false,
            state:-1, //0 审核中 1 审核通过 2 拒绝
            reason:'',
        }
    },
    created() {
        this.pid = Number(this.$route.params.id || 0)
        this.pname = this.$route.params.title
        this.$emit('setIndex', [1,0], `${this.pname}- 权重赋分`, true)
        this.init()
    },
    computed: {
        user() {
            return this.$store.state.user
        }
    },
    methods: {
        inputChange(_id,cur_id,cur_score,score) {
            let _item = this.lists.find(f => {
                return _id === f[cur_id]
            })
            let _index = this.lists.findIndex(f => {
                return _id === f[cur_id]
            })
            this.lists[_index][score]= this.lists.filter(f => {
                return _id === f[cur_id]
            }).reduce((pre, next) => {
                return pre + (Number(next[cur_score] || 0))
            }, 0)
            if (cur_id === 'two_id') this.inputChange(_item.one_id,'one_id','two_score','one_score')
            if (cur_id === 'three_id') this.inputChange(_item.two_id,'two_id','three_score','two_score')
        },
        async submitApply() {
            let _error = ''
            let _id = 0
            const one_sum = this.lists.reduce((pre, next) => {
                if ((next.one_score === '' || next.one_score < 0 || next.one_score > 100) && !_error && _id !== next.one_id) _error = `${next.one_name}赋分错误`
                _id = next.one_id
                return pre + (next.one_score || 0)
            }, 0)
            if (one_sum !== 100 && !_error) _error = '一级指标权重赋分赋分错误'
            const two_sum = this.lists.reduce((pre, next) => {
                if ((next.two_score === '' || next.two_score < 0 || next.two_score > 100) && !_error && _id !== next.two_id) _error = `${next.two_name}赋分错误`
                _id = next.two_id
                return pre + (next.two_score || 0)
            }, 0)
            if (two_sum !== 100 && !_error) _error = '二级指标权重赋分赋分错误'
            if (_error) return toast(_error, TOAST.error)
            let _result = []
            this.lists.map(item => {
                if (item.one_id && _result.every(e=> item.one_id !== e.id)) _result.push({id:item.one_id, score:item.one_score})
                if (item.two_id && _result.every(e=> item.two_id !== e.id)) _result.push({id:item.two_id, score:item.two_score})
                if (item.three_id && _result.every(e=> item.three_id !== e.id)) _result.push({id:item.three_id, score:item.three_score})
                if (item.four_id && _result.every(e=> item.four_id !== e.id)) _result.push({id:item.four_id, score:item.four_score})
            })
            this.loading = true
            let _data = await setTaskScoreEx(this.pid,JSON.stringify(_result))
            this.loading = false
            if (_data.status === 200) {
                toast(`提交成功`, TOAST.success)
                this.$router.go(-1)
            }else {
                toast(_data.msg, TOAST.error)
            }
        },
        async init() {
            let _data = await getProjectStatus(this.pid)
            this.readonly =  _data.data.is_operation === 0
            _data = await getTaskScoreEx(this.pid, 0)
            if ( _data.data.log){
                this.state = _data.data.log.state
                this.reason = _data.data.log.reason || ''
                this.readonly = this.readonly || this.state === 0 || this.state === 1
            }
            _data.data.list.map((item) => {
                if (item.children.length === 0) {
                    this.lists.push(this.customData(item.id, item.name, Number(item.score || 0)))
                } else {
                    item.children.map((two,two_index) => {
                        if (two.children.length === 0) {
                            this.lists.push(this.customData(item.id, item.name, Number(two_index === 0 ? (item.score || 0) : 0), two.id, two.name, Number(two.score || 0)))
                        } else {
                            two.children.map((three,three_index) => {
                                if (three.children.length === 0) {
                                    this.lists.push(this.customData(item.id, item.name,  Number(two_index + three_index  === 0 ? (item.score || 0) : 0), two.id, two.name, Number(three_index === 0 ? (two.score || 0) : 0), three.id, three.name, Number(three.score||0)))
                                } else {
                                    three.children.map((four,four_index) => {
                                        this.lists.push(this.customData(item.id, item.name,  Number(two_index + three_index + four_index === 0 ? (item.score || 0) : 0), two.id, two.name, Number(three_index + four_index === 0 ? (two.score || 0) : 0), three.id, three.name, Number(four_index === 0 ? (three.score || 0) : 0), four.id, four.name, Number(four.score)))
                                    });
                                }
                            })
                        }

                    })
                }
            })
            this.getSpanArr(this.lists)
            this.loading = false
        },
        customData(one_id, one_name, one_score, two_id = '', two_name = '--', two_score = '', three_id = '', three_name = '--', three_score = '', four_id = '', four_name = '--', four_score = '') {
            return {
                one_id,
                one_name,
                one_score,
                two_id,
                two_name,
                two_score,
                three_id,
                three_name,
                three_score,
                four_id,
                four_name,
                four_score
            }
        },
        getSpanArr(data) {
            this.column_1 = []
            this.column_2 = []
            this.column_3 = []
            this.column_4 = []
            for (let i = 0; i < data.length; i++) {
                if (i === 0) {
                    this.column_1.push(1);
                    this.column_2.push(1);
                    this.column_3.push(1);
                    this.column_4.push(1);
                    this.pos_1 = 0
                    this.pos_2 = 0
                    this.pos_3 = 0
                    this.pos_4 = 0
                } else {
                    // 判断当前元素与上一个元素是否相同
                    if (data[i].one_id === data[i - 1].one_id) {
                        this.column_1[this.pos_1] += 1;
                        this.column_1.push(0);
                    } else {
                        this.column_1.push(1);
                        this.pos_1 = i;
                    }
                    if (data[i].two_id === data[i - 1].two_id && data[i].one_id === data[i - 1].one_id) {
                        this.column_2[this.pos_2] += 1;
                        this.column_2.push(0);
                    } else {
                        this.column_2.push(1);
                        this.pos_2 = i;
                    }
                    if (data[i].three_id === data[i - 1].three_id && data[i].one_id === data[i - 1].one_id) {
                        this.column_3[this.pos_3] += 1;
                        this.column_3.push(0);
                    } else {
                        this.column_3.push(1);
                        this.pos_3 = i;
                    }
                    if (data[i].four_id === data[i - 1].four_id && data[i].one_id === data[i - 1].one_id) {
                        this.column_4[this.pos_4] += 1;
                        this.column_4.push(0);
                    } else {
                        this.column_4.push(1);
                        this.pos_4 = i;
                    }
                }
            }
        },
        objectSpanMethod({rowIndex, columnIndex}) {
            if (columnIndex === 0 || columnIndex === 1) {
                const _row = this.column_1[rowIndex];
                const _col = _row > 0 ? 1 : 0;
                return { // [0,0] 表示这一行不显示， [2,1]表示行的合并数
                    rowspan: _row,
                    colspan: _col
                }
            } else if (columnIndex === 2 || columnIndex === 3) {
                const _row = this.column_2[rowIndex];
                const _col = _row > 0 ? 1 : 0;
                return { // [0,0] 表示这一行不显示， [2,1]表示行的合并数
                    rowspan: _row,
                    colspan: _col
                }
            } else if (columnIndex === 4 || columnIndex === 5) {
                const _row = this.column_3[rowIndex];
                const _col = _row > 0 ? 1 : 0;
                return { // [0,0] 表示这一行不显示， [2,1]表示行的合并数
                    rowspan: _row,
                    colspan: _col
                }
            } else {
                const _row = this.column_4[rowIndex];
                const _col = _row > 0 ? 1 : 0;
                return { // [0,0] 表示这一行不显示， [2,1]表示行的合并数
                    rowspan: _row,
                    colspan: _col
                }
            }
        },
        addTask(data) {
            if (!data) return
            this.cur_task_id = data
            this.addTaskDialog = true
        },
        watchDetailState() {
            this.cur_task_id = 0
            this.addTaskDialog = false
        },
        getSummaries(param) {
            const {columns, data} = param;
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '总分';
                    return;
                } else if (index === 1 || index ===  3 || index === 5 || index === 7) {
                    console.log()
                    const values = data.map(item => Number(item[column.property]));
                    if (!values.every(value => isNaN(value))) {
                        sums[index] = values.reduce((prev, curr) => {
                            const value = Number(curr);
                            if (!isNaN(value)) {
                                return prev + curr;
                            } else {
                                return prev;
                            }
                        }, 0);
                        sums[index] += '';
                    } else {
                        sums[index] = '--';
                    }
                } else {
                    sums[index] = '--';
                    return
                }

            });
            return sums;
        }
    },
    filters: {
        status(check_status) {
            //验收状态 1正常验收 2非正常验收
            switch (Number(check_status)) {
                case 0 :
                    return '审核中'
                case 1 :
                    return '已通过'
                case 2 :
                    return '已拒绝：'
            }
        },
        status_color(check_status) {
            //验收状态 1正常验收 2非正常验收
            switch (Number(check_status)) {
                case 0 :
                    return 'bg-orange'
                case 1 :
                    return 'bg-green'
                case 2 :
                    return 'bg-red'
            }
        }
    },

}
</script>

<style lang="scss" scoped>
.page-wrapper {
    .status{
        padding: 12px 24px;
    }
}
</style>
